import { Grid, Button, Container } from "@mui/material";

const SubmitForm = () => {
  return (
    <Button variant="contained" color="success" type="submit">
      Submit
    </Button>
  );
};

export default SubmitForm;
